import React from "react";
import "./productStyles.css";
import Dropzone from "../DropzoneFSA_PFD";
import background from "../assets/pfsa.png";
import DROPZONE_DATA from "../DROPZONE_DATA";
import "./productStyles.css"; //* migrate styles added by js for the products to this stylesheet

export default function P_fsa({
  handleWarningMessageText,
  handleDropzoneChanges,
  handleContinueButtonDisabled
}) {
  return (
    <div className="portraitProductContainer">
      <img
        alt=""
        className="backgroundImageContainer portrait"
        src={background}
      ></img>
      {/* <div className="pFullScreen" style={pFullScreen}> */}
      <div className="portraitFullScreen">
        <Dropzone
          acceptedFileTypeString={DROPZONE_DATA.data.imageAndVideo}
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          droppedFileType="portrait"
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      </div>
    </div>
  );
}
